import React, { useState, useEffect, useRef, useReducer } from 'react'
import { useForm } from 'react-hook-form'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { searchCompanies } from '../../../services/apiHelper'

const pStyle = 'tal p0 ml10 mt0 mb0 fz15'
const CompanyDetailsWidget = ({ returnData, companyName }) => {

  const { handleSubmit, watch, setValue } = useForm()
  const formReducer = (state, action) => {
    switch (action.type) {
      case 'PERMIT_SEARCH':
        return { ...state, permitSearch: true }
      case 'SET_BY_CLICK':
        setValue('companyName', action.payload.name)
        return { ...state, permitSearch: false, setBy: 'CLICK', company_details:  action.payload }
      case 'SET_BY_PROPS':
        setValue('companyName', action.payload)
        return { ...state, permitSearch: false, setBy: 'PROPS' }
      case 'SET_BY_SAP_ID':
        setValue([
          { growerName : action.payload.grower_name },
          { resellerName : action.payload.reseller_name },
          { resellerNumber : action.payload.reseller_sap_id }
        ])
        return { ...state, permitSearch: false, setBy: 'SAP_ID' }
      default:
        return { ...state }
    }
  }
  const [formState, formDispatch] = useReducer(formReducer, { permitSearch: true })
  const [, setCompanyNameData] = useState([])
  const watchCompanyName = watch('companyName', '')

  const onSubmit = () => {
    return null
  }

  useEffect(()=> {
    if(companyName){
      formDispatch({ type: 'SET_BY_PROPS', payload: companyName  })
    }
  }, [companyName])

  useEffect(()=> {
    if(formState.permitSearch) {
      if(prevSearch.current !== watchCompanyName &&
      watchCompanyName.length >= 3) {
        searchCompanies(watchCompanyName)
          .then(res => {
            setCompanyNameData(res)
          })
      }
    } else {
      formDispatch({ type: 'PERMIT_SEARCH' })
    }
  }, [
    watchCompanyName, setCompanyNameData, formState.permitSearch
  ])

  const prevSearch= useRef()
  useEffect(()=> {
    prevSearch.current = watchCompanyName
  })

  useEffect(()=> {
    if(formState.company_details){
      returnData(formState.company_details)
    }
  }, [formState.company_details, returnData])

  return (
    <Widget title='Company details'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mt20 df aic jcfs'>
          <div className='w45%'>
            <label className='df mb10' htmlFor='companyName'>Company name</label>
            <p className={pStyle}>{companyName}</p>
          </div>
        </div>
        
      </form>
    </Widget>)
}

export default CompanyDetailsWidget